import PromoList from './PromoList'
export {PromoList}
export default PromoList
